import type { SidePanelFormFooterProps } from "./side-panel-form-footer.type";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { useTranslation } from "react-i18next";

import { SidePanelFooter, useSidePanel } from "@/modules/side-panel";

const SidePanelFormFooter = ({
  closeType = "cancel",
  hideSubmit,
  submitProps = {},
  submitText,
  position,
}: SidePanelFormFooterProps) => {
  const { t } = useTranslation();
  const { closeSidePanel } = useSidePanel();
  const isCloseButton = closeType === "close";

  return (
    <SidePanelFooter position={position}>
      <Space>
        <Button
          onClick={closeSidePanel}
          icon={isCloseButton ? <CloseOutlined /> : undefined}
        >
          {isCloseButton ? t("global:close") : t("global:cancel")}
        </Button>
        {!hideSubmit && (
          <Button type="primary" htmlType="submit" {...submitProps}>
            {submitText ?? t("global:update")}
          </Button>
        )}
      </Space>
    </SidePanelFooter>
  );
};

export default SidePanelFormFooter;
